import {findRawResourceByAttributeId} from './plan_data/userData'

const EMPTY_PROVISIONING_URI = {searchParams: new URLSearchParams()}

/**
 * Gets the whitelisted firm user IDs from settings that should skip mandatory TFA.
 *
 * @param {Array} settings
 *
 * @returns {Array} Array of firm user ID strings
 */
export const getWhitelistedFirmUserIdsForTfa = ({settings}) => {
  const record = findRawResourceByAttributeId({
    rawResource: settings,
    id: 'whitelisted_firm_user_ids_to_skip_tfa',
    attribute: 'name'
  })

  const value = record.get('value', '')
  return value ? value.split(',').map(id => id.trim()).filter(id => id) : []
}

/**
 * Checks if a firm user should skip mandatory TFA setup for funeral homes.
 *
 * @param {String|Number} firmUserId - The firm user ID to check
 * @param {Array} settings - Settings containing the whitelist
 *
 * @returns {Boolean} True if the firm user is whitelisted to skip TFA
 */
export const isFirmUserWhitelistedForTfaSkip = ({firmUserId, settings}) => {
  if (!firmUserId) return false

  const whitelistedIds = getWhitelistedFirmUserIdsForTfa({settings})
  return whitelistedIds.includes(String(firmUserId))
}

export const parseProvisioningUri = provisioningUri => {
  if (!provisioningUri)
    return EMPTY_PROVISIONING_URI

  try {
    return new URL(provisioningUri)
  } catch {
    return EMPTY_PROVISIONING_URI
  }
}

/**
 * Mirrors the server-side OR check used by InterstitialService and
 * Clients::OnboardingService: mandatory TFA is required when EITHER
 * the firm-level or organization-level flag is enabled. Both args are
 * optional Immutable Maps; missing/empty maps are treated as "not enabled".
 *
 * @param {Object} [params]
 * @param {Map} [params.organizationConfig]
 * @param {Map} [params.firmConfig]
 *
 * @returns {boolean}
 */
export const isMandatoryTfaEnabled = ({organizationConfig, firmConfig} = {}) =>
  Boolean(
    (firmConfig && firmConfig.get && firmConfig.get('mandatory-tfa-enabled')) ||
    (organizationConfig && organizationConfig.get && organizationConfig.get('mandatory-tfa-enabled'))
  )
